import _ from "lodash";

/**
 * Spellings of the start-date param accepted on the detail-tour URL.
 *
 * The page originally read only `startdate`, but the WordPress theme linked with
 * `start_date` for a long time (and its now-deprecated "Check Dates" form used
 * `startDate`). Query params are case-sensitive, so those links silently did
 * nothing: no date preselect, and no scroll to the pricing section — which read
 * as a missing feature when the machinery was already there and correct.
 *
 * The theme now sends `startdate`, so this is belt-and-braces: it keeps links
 * already published elsewhere working, and makes the next mismatch fail soft.
 */
export const START_DATE_PARAM_KEYS = ["startdate", "startDate", "start_date"];

interface IReadableParams {
    get(key: string): string | null;
}

/**
 * `?startdate=` in any of the spellings the linking sites use, trimmed.
 * Null when absent or blank. The canonical spelling wins if several are present.
 */
export const readStartDateParam = (params: IReadableParams): string | null => {
    for (const key of START_DATE_PARAM_KEYS) {
        const value = params.get(key);
        if (!_.isNil(value) && value.trim() !== "") return value.trim();
    }
    return null;
};
